import {
    SortColumns,
    SortDirections,
    ListTypes,
} from '@telstra-connect/service-requests/helpers/sort-param-constants';
export interface IViewRequestTabs {
    summary: string;
    activity: string;
}

export default class Routes {
    public static get ServiceRequests(): string {
        return '/service-requests';
    }

    public static get RequestSubTab(): string {
        return 'requests';
    }

    public static get InternetProduct(): string {
        return 'internet';
    }

    public static get Devices(): string {
        return 'mobile-device-management/device_info';
    }
    public static get NewRequest(): string {
        return 'new-request';
    }

    public static get Modifications(): string {
        return 'manage';
    }

    public static get Open(): string {
        return '/service-requests/open';
    }

    public static get Closed(): string {
        return '/service-requests/closed';
    }

    public static get OpenRequestRouteV6(): string {
        return '/app/service-requests/open/*';
    }

    public static get ClosedRequestRouteV6(): string {
        return '/app/service-requests/closed/*';
    }

    public static get ViewRequestRoute(): string {
        return 'view/:tabState/:serviceRequestId/:tab';
    }
    // dummy route for actual url
    public static get ViewInternetProductRequestRoute(): string {
        return 'view/:tabState/:requestedItem/:tab';
    }

    public static get ViewStrategicRequestRoute(): string {
        return 'view/:tabState/:serviceRequestId/:requestedItem/:tab';
    }

    public static get ViewInternetProductRoute(): string {
        return 'view/internet/:requestedItem/:tab';
    }

    public static get OpenRequestRoute(): string {
        return '/app/service-requests/open';
    }

    public static get ClosedRequestRoute(): string {
        return '/app/service-requests/closed';
    }

    public static get ViewRequestTabs(): IViewRequestTabs {
        return {
            summary: 'summary',
            activity: 'activity',
        };
    }
    public static get DeviceDetails(): string {
        return 'device-detail/:deviceTypeId/:tenancyID/:userName/detail';
    }
    public static get MDUMDetailsRoute(): string {
        return '/app/mobile-data-usage-meter/serviceDetails/strategic/sharedFair/' +
            ':chargeId/:billingNumber/:subscriptionId/:mobileNumber'
    }

    public static get MaximRequestList(): string {
        return '/service-requests/all-requests/mobile-and-other-requests';
    }
    public static get mobilePlansAndServicesList(): string {
        return 'mobile-services';
    }
    public static get servicesListFNC(): string {
        return 'fnc-services';
    }
    public static get mobileChangeRequestForm(): string {
        return 'mobile-services-request-form';
    }
    public static get FNCForm(): string {
        return 'fnc-services/request-form';
    }
    public static get NBNDiagnostics(): string {
        return 'nbn-diagnostics';
    }
    public static get ViewHistoryRoute(): string {
        return `nbn-diagnostics/:serviceId`;
    }
    public static get SubmitABugURL(): string {
        return '/app/support/error-report';
    }
    public static get ypsCataloguePageURL(): string {
        return ':ypsLandingPageURL/:productFamilyKey/request-catalogue';
    }
    public static get ypsMaximFormPageURL(): string {
        return `:ypsLandingPageURL/:productFamilyKey/:productCatalogue/${this.maximFormURL}`;
    }
    public static get ypsMobilitySolutionsURL(): string {
        return `:ypsLandingPageURL/:productFamilyKey/:productCatalogue/${this.mobilitySolutionsURL}`;
    }
    public static get ypsLandingPageURL(): string {
        return 'your-products-and-services';
    }
    public static get ypsFormPageURL(): string {
        return 'your-products-and-services/:productFamilyKey/form';
    }
    public static get maximFormURL(): string {
        return 'maxim-form';
    }
    public static get mobilitySolutionsURL(): string {
        return 'mobility-solutions';
    }
    public static get ypsMobileServicesPageWithMobileNumber(): string {
        return ':ypsLandingPageURL/:productFamilyKey/:productCatalogue/mobile-services/:mobileNumber/list';
    }
    public static get ypsMobileServicesPage(): string {
        return ':ypsLandingPageURL/:productFamilyKey/:productCatalogue/mobile-services';
    }
    public static get maximFormFromMobileServicesPage(): string {
        return `${this.mobilePlansAndServicesList}/${this.maximFormURL}`;
    }
    public static get mobilitySolutionsFromMobileServicesPage(): string {
        return `${this.mobilePlansAndServicesList}/${this.mobilitySolutionsURL}`;
    }
    public static get allRequestsListPageURL(): string {
        return 'all-requests';
    }
    public static get maximRequests(): string {
        return 'mobile-and-other-requests';
    }
    public static get maximActivitiesRoute(): string {
        return 'mobile-and-other-activities';
    }
    public static get maximDetailPage(): string {
        return 'all-requests/mobile-and-other-activities/:TRN/summary'
    }
    public static get fncRequests(): string {
        return 'fnc-requests';
    }
    public static get requests(): string {
        return 'requests/*';
    }
    public static get viewRequestRouteFromYPSPage(): string {
        return `${this.ypsCataloguePageURL}/view/:tabState/:serviceRequestId/:tab`;
    }
    public static get billingTileRoute() {
        return `/app/billing/summary/invoices?billingAccount=:accountNumber`
    }
    public static get mobilitySolutionsCatalogue(): string {
        return 'your-products-and-services/mobility-solutions/request-catalogue'
    }
    public static get mobileServicesPageFixedRoute() {
        return 'your-products-and-services/mobility-solutions/mobile-plans-and-devices/mobile-services'
    }
    public static get supportEnquiryPath() {
        return '/customer-support/new-enquiry-form?category=Your%20products%20or%20services'
    }
    public static get helpAndSupportPath() {
        return '/customer-support/new-enquiry'
    }
    public static get viewAllServiceTypesPath() {
        return '/app/service-performance/sites-services-status/services'
    }
    public static get mobileServicesDetailStrategic(): string {
        return Routes.mobileServicesPageFixedRoute + '/:userStack/:serviceNumber/detail'
    }
    public static get ViewMobileServicesListMdum(): string {
        return '/app/mobile-data-usage-meter/mobile-services'
    }

    public static get mobileRequestDetail(): string {
        return this.ypsMobileServicesPage.replace(
            ':ypsLandingPageURL', 'your-products-and-services'
        ).replace(
            ':productFamilyKey', 'mobility-solutions'
        ).replace(
            ':productCatalogue', 'mobile-plans-and-devices'
        ) + '/:mobileNumber/detail'
    }

    public static get ViewMobileServicesListMobility(): string {
        return '/app/mobility/mobile-services'
    }
    public static get ViewInternetProductDnsRoute(): string {
        return 'view/internet/dns/:requestedItem/:tab';
    }

    public static get mobileServicesDetailStrategicRoute(): string {
        return '/app/mobility/mobile-services/:userStack/:serviceNumber/detail'
    }

    public static ViewStrategicRequest(
        tabState: string,
        serviceRequestId: string,
        requestedItem: string,
        tab: string
    ): string {
        return this.ViewStrategicRequestRoute.replace(':tabState', tabState)
            .replace(':serviceRequestId', serviceRequestId)
            .replace(':requestedItem', requestedItem)
            .replace(':tab', tab);
    }

    public static RequestList(
        listType: ListTypes,
        sortBy: SortColumns,
        sortDirection: SortDirections
    ) {
        return `${listType}?sort=${sortBy}:${sortDirection}`;
    }

    public static NBNHistoryPage(serviceId: string): string {
        return this.ViewHistoryRoute.replace(':serviceId', serviceId)
    }
    public static ViewMaximDetailsPage(TRN: string) {
        return Routes.maximDetailPage.replace(':TRN', TRN);
    }

    public static ViewDeviceDetail(
        deviceTypeId: number,
        tenancyID: number,
        userName: string
    ): string {
        return this.DeviceDetails.replace(
            ':deviceTypeId',
            encodeURIComponent(deviceTypeId.toString())
        )
            .replace(':tenancyID', encodeURIComponent(tenancyID.toString()))
            .replace(':userName', encodeURIComponent(userName));
    }
    public static ViewRequest(
        tabState: string,
        serviceRequestId: string,
        tab: string
    ): string {
        return this.ViewRequestRoute.replace(':tabState', tabState)
            .replace(':serviceRequestId', serviceRequestId)
            .replace(':tab', tab);
    }

    public static ViewInternetProductRequest(
        tabState: string,
        requestedItem: string,
        tab: string
    ): string {
        return this.ViewInternetProductRequestRoute.replace(':tabState', tabState)
            .replace(':requestedItem', requestedItem)
            .replace(':tab', tab);
    }

    public static ViewInternetProductDNSRequest(
        tabState: string,
        requestedItem: string,
        tab: string
    ): string {
        return this.ViewInternetProductDnsRoute.replace(':tabState', tabState)
            .replace(':requestedItem', requestedItem)
            .replace(':tab', tab);
    }

    public static MDUMDetails(
        chargeId: string,
        billingNumber: string,
        subscriptionId: string,
        mobileNumber: string
    ): string {
        return this.MDUMDetailsRoute.replace(':chargeId', chargeId)
            .replace(':billingNumber', billingNumber)
            .replace(':subscriptionId', subscriptionId)
            .replace(':mobileNumber', mobileNumber);
    }

    public static setYPSPageURL(
        productFamilyKey: string
    ): string {
        return this.ypsFormPageURL
            .replace(':productFamilyKey', productFamilyKey);
    }

    public static setMobileRequestDetailRoute(mobileNumber: string): string {
        return this.mobileRequestDetail.replace(
            ':mobileNumber', mobileNumber
        )
    }
    public static setBillingTileRoute(accountNumber: string) {
        return this.billingTileRoute.replace(
            ':accountNumber', accountNumber
        )
    }
    public static unifiedTrackingPath(): string {
        return '/tracking/requests'
    }

    public static ViewMobileServicesDetailStrategic(
        serviceNumber: string,
        userStack: string,
    ): string {
        return this.mobileServicesDetailStrategicRoute.replace(':userStack', encodeURIComponent(userStack))
            .replace(':serviceNumber', encodeURIComponent(serviceNumber))
    }

    public static PerformanceServicesWithPlannedMaintenanceFilter(): string {
        return this.viewAllServiceTypesPath + '?status=Planned%20maintenance'
    }
}
